function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        /* keep the label Liquid just rendered (Pre-order / Add to cart / Sold out) instead of the generic string */
        const updatedSpan = addButtonUpdated && addButtonUpdated.querySelector('span');
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
          true,
          updatedSpan ? updatedSpan.textContent : null
        );
        if (window.__rrPaintPre) window.__rrPaintPre();

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, enabledText = null) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = enabledText || window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

  // Collection/product-card color swatches (vanilla; formerly jQuery)
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    var parent = swatch.closest('.product-card-wrapper');
    if (!parent) return;
    var id = swatch.getAttribute('data-variant-id');
    var name = swatch.getAttribute('data-swatch');
    parent.querySelectorAll('[name="id"]').forEach(function(el) { el.value = id; });
    parent.querySelectorAll('[data-swatch]').forEach(function(el) { el.classList.remove('active'); });
    parent.querySelectorAll('.system-variant').forEach(function(el) { el.classList.add('hidden'); });
    parent.querySelectorAll('.system-variant[data-swatch-toggle="' + name + '"]').forEach(function(el) { el.classList.remove('hidden'); });
    parent.querySelectorAll('[data-swatch="' + name + '"]').forEach(function(el) { el.classList.add('active'); });
    parent.querySelectorAll('.currentColor').forEach(function(el) { el.innerHTML = name; });
  });
  function mergeObjects(target) {
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index] !== null && arguments[index] !== undefined ? arguments[index] : {};
      if (index % 2) {
        // Iterate over own enumerable keys of source objects
        Object.keys(Object(source)).forEach(function(key) {
          // Assign the value of the source object's property to the target object
          target[key] = source[key];
        });
      } else {
        // Use Object.getOwnPropertyDescriptors if available, otherwise define properties individually
        if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          Object.keys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }
    }
    return target;
  }
  
  // Variable declaration using an immediately invoked function expression (IIFE)
  var rinoData = (function() {
    if (!window.RINO || !window.RINO.products)
      return [{}, {}];
    var productsMap = {};
    var variantsMap = {};
    window.RINO.products.forEach(function(product) {
      productsMap[product.id] = mergeObjects({}, product);
      product.variants.forEach(function(variant) {
        variantsMap[variant.id] = mergeObjects(mergeObjects({}, variant), {}, {
          featured_image: (variant.featured_image && variant.featured_image.src) || product.featured_image,
          productId: product.id
        });
      });
    });
    return [productsMap, variantsMap];
  })();

  async function getCartTotalMinusPack(packId) {
    var calculateInCents = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    var response = await getCartState();
    if (!response) return;
    var items = response.items;
    var total = items.reduce(function (accumulator, currentItem) {
      var properties = currentItem.properties;
      var packIdOfItem = properties ? properties.packId : undefined;
      if (packIdOfItem && packIdOfItem === parseInt(packId, 10)) {
          return accumulator;
      } else {
          return accumulator + currentItem.final_line_price;
      }
    }, 0);

    return total;
  }
  async function isProductInCart(productId) {
    var response = await getCartState();
    if (!response) return;
    return response.items.some(function (item) {
      return item.product_id === parseInt(productId, 10);
    });
  }
  function getProductByHandle(handle) {
    var products = rinoData[0];
    var productArray = Object.values(products);
    return productArray.find(function (product) {
        return product.handle === handle;
    });
  }
  const addRemoveGiftsFromCart = async function(totalPrice, reload = true) {
    var cart = window.RINO.cart;
    if (typeof totalPrice === 'undefined') {
      totalPrice = cart.total_price;
    }
    var giftContainer = document.querySelector("[data-gift]");
    if (!giftContainer) {
      return;
    }
    var giftProducts = giftContainer.querySelectorAll("[data-gift-product]");
    var toAdd = [];
    var toRemove = [];
    giftProducts.forEach(async function (gift) {
      var product = getProductByHandle(gift.getAttribute("data-gift-product"));
      var price = Number(gift.getAttribute("data-gift-price"));
      if (product && !isNaN(price) && product.variants[0].available) {
        var isInCart = await isProductInCart(product.id);
        if (totalPrice >= price && !isInCart) {
          toAdd.push({
            quantity: 1,
            id: product.variants[0].id
          });
        } else if (totalPrice < price && isInCart) {
          toRemove.push(product);
        }
      }
    });
    setTimeout(function() {
      if (toAdd.length) {
        // addItemsToCart(toAdd);
      }
      if (toRemove.length) {
        const items = toRemove.reduce((accumulator, currentItem) => {
          accumulator[currentItem.variants[0].id] = 0;
          return accumulator;
        }, {});
        // updateCartItems(items);
      }
    }, 1500)
  }
  var mainTotal = 0, mainTitle, currentTitle;
  function updateGiftBars(totalPrice, element = document, showToast = true) {
    var giftContainers = element.querySelectorAll("[data-gift]");
    giftContainers.forEach(function (container) {
      var giftProducts = container.querySelectorAll("[data-gift-product]");
      var nextAmount = container.querySelector("[data-gift-next-amount]");
      var nextTitle = container.querySelector("[data-gift-next-title]");
      var unlockedTitle = '';
      var unlockedAmount = 0;
      var lastAmount = 100;
      var lastPrice = 0;
      var currentPrice = 0;
      var progress = 0;
      giftProducts.forEach(function (gift) {
        var product = getProductByHandle(gift.getAttribute("data-gift-product"));
        var price = Number(gift.getAttribute("data-gift-price"));
        if (product && !isNaN(price)) {
          progress = (totalPrice - lastPrice) / (price - lastPrice) * 100;
          if (progress > 100) {
            progress = 100;
          }
          if (lastAmount < 100) {
            progress = 0;
          }
          if (lastAmount == 100 && progress < 100) {
            unlockedTitle = product.title;
            unlockedAmount = price - totalPrice;
          }
          lastAmount = progress;
          lastPrice = price;
          gift.style.setProperty("--progress", progress + "%");
          gift.classList.toggle("checked", price <= totalPrice);
          var k = 0 === unlockedAmount;
          container.classList.toggle("gift--unlocked", k)
          if (price <= totalPrice) {
            currentTitle = product.title;
          }
        }
      });
      nextTitle.innerHTML = unlockedTitle;
      nextAmount.innerHTML = Shopify.formatMoney(unlockedAmount).replace('.00', '');
    });
    if (showToast && totalPrice > mainTotal && mainTitle !== currentTitle) {
      openToast("<strong>" + currentTitle + " unlocked!</strong> (Can be found in cart after completing pack)");
    }
    mainTotal = totalPrice;
    mainTitle = currentTitle;
  };
  var toastElement;

  function getToastElement() {
    return toastElement || (toastElement = document.querySelector("[data-toast]"));
  }
  
  function openToast(message) {
    var toast = getToastElement();
    if (toast) {
      toast.classList.remove("active");
      toast.innerHTML = message;
      toast.classList.add("active");
      setTimeout(function() {
        closeToast();
      }, 4000);
    }
  }
  
  function closeToast() {
    var toast = getToastElement();
    if (toast) {
      setTimeout(function() {
        closeToast();
      }, 4000);
      toast.classList.remove("active");
    }
  }
  
  function initToast() {
    var toast = getToastElement();
    if (toast) {
      toast.addEventListener("click", closeToast);
    }
  }


  function generateProductOptions(product) {
    var data = [];
    product.options.forEach(function(option) {
      data.push({
        title: option,
        options: []
      })
    })
    product.variants.forEach((function(variant) {
      variant.options.forEach((function(option, i) {
        if (!data[i].options.includes(option)) {
          data[i].options.push(option);
        }
      }))
    }))
    return data;
  }
  function getVariantFromOptions(productId, data) {
    var product = getProduct(productId);
    return product.variants.find((function(variant) {
      var options = variant.options;
      return JSON.stringify(options) === JSON.stringify(data)
    })) || null
  }
  function getProduct(id) {
    return rinoData[0][id];
  }
  function getVariant(id) {
    return rinoData[1][id];
  }
  // (pack customizer engine removed 2026-09-01; see docs/customizer-retirement-map.md)
  // Define action constants
  const ADD = "ADD";
  const CHANGE = "CHANGE";
  const UPDATE = "UPDATE";
  const CART = "CART";
  const CART_HTML = "CART_HTML";
  const CART_DRAWER_HTML = "CART_DRAWER_HTML";
  
  // Define function to interact with the server
  const performServerAction = async function(data, action = ADD) {
      let url = "/cart/add.js";
      let method = action.includes("CART") ? "GET" : "POST";
  
      if (action === CHANGE) url = "/cart/change.js";
      if (action === UPDATE) url = "/cart/update.js";
      if (action === CART) url = "/cart.js";
      if (action === CART_HTML) url = "/cart";
      if (action === CART_DRAWER_HTML) url = window.location.pathname;
  
      try {
          // Perform fetch request
          const response = await fetch(url, {
              method: method,
              credentials: "same-origin",
              headers: {
                  "Content-Type": action.includes("HTML") ? "text/html" : "application/json",
                  "X-Requested-With": "xmlhttprequest",
                  "Cache-Control": "no-cache, no-store, must-revalidate",
                  Pragma: "no-cache",
                  Expires: 0
              },
              body: data && JSON.stringify(data)
          });
  
          // Parse response
          const responseData = await (action.includes("HTML") ? response.text() : response.json());
  
          // Handle response
          if (responseData.status) {
              throw new Error(responseData.description);
          }
  
          return responseData;
      } catch (error) {
          console.error(error);
      }
  };
  
  // Define function to add items to the cart
  const addItemToCart = async function(itemId, qty = 1, redirectToCart = true) {
    const item = {
      id: itemId,
      quantity: qty
    };

    try {
      const response = await performServerAction(item);
      if (!response) return;
      if (redirectToCart) {
        window.location.href = "/cart";
      } else {
        if (window.location.href.indexOf('/cart') > -1) {
          updateCart();
        } else {
          updateCartDrawer();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to remove pack from cart
  const removePackFromCart = async function(packId, removeFromCart = true) {
    const response = await getCartState();
    if (!response) return;
    const items = response.items.reduce((accumulator, currentItem) => {
      const key = currentItem.key;
      const properties = currentItem.properties;
      if (properties && properties.packId === parseInt(packId, 10)) {
        accumulator[key] = 0;
      }
      return accumulator;
    }, {});

    if (Object.keys(items).length) {
      await updateCartItems(items, removeFromCart);
    }
  };
  
  // Define function to add multiple items to cart
  const addItemsToCart = async function(items, redirectToCart = true) {
    try {
      const response = await performServerAction({ items: items });
      if (!response) return;
      if (window.location.href.indexOf('/cart') > -1) {
        updateCart();
      } else {
        updateCartDrawer();
      }
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to update cart items
  const updateCartItems = async function(updates, redirectToCart = true) {
    try {
      const response = await performServerAction({ updates: updates }, UPDATE);
      if (!response) return;
      if (window.location.href.indexOf('/cart') > -1) {
        updateCart();
      } else {
        updateCartDrawer();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const updateCartSingleItems = async function(id, quantity) {
    try {
      const dataToSend = {
        id: id,
        quantity: quantity
      };
      const response = await performServerAction(dataToSend, CHANGE);
      if (!response) {
        return;
      }
      if (window.location.href.indexOf('/cart') > -1) {
        updateCart();
      } else {
        updateCartDrawer();
      }
    } catch (error) {
        console.error(error);
    }
  }

  
  // Define function to get cart state
  const getCartState = async function() {
    try {
      const cartData = await performServerAction(null, CART);
      if (!cartData) return;
      return cartData;
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to update cart item count
  const updateCartItemCount = function(count) {
    const cartItemCountElement = document.querySelector(".cart-count-bubble span:first-child");
    if (cartItemCountElement) {
      cartItemCountElement.innerHTML = count || 0;
    }
  };
  
  // Define function to disable/enable cart submit button
  const disableCartSubmitButton = function(disabled) {
    const cartSubmitButton = document.querySelector("[data-cart-submit]");
    if (cartSubmitButton) {
      cartSubmitButton.toggleAttribute("disabled", disabled);
    }
  };
  
  // Define function to update cart submit button
  const updateCartSubmitButton = function(totalPrice) {
    disableCartSubmitButton(true);
  };

  const updateCartState = async function() {
    try {
      const response = await getCartState();
      if (!response) return;
      updateCartSubmitButton(response.total_price);
      updateGiftBars(response.total_price);
      return response;
    } catch (error) {
      console.error(error);
    }
  };
  
  // Define function to update cart
  const updateCart = async function(forceUpdate) {
    const cartContentElement = document.querySelector("[data-cart-content]");
    let updateCart = forceUpdate;
    if (!updateCart) updateCart = await updateCartState();
    await addRemoveGiftsFromCart(updateCart.total_price);
    await performServerAction(null, CART_HTML).then(cartHtml => {
      if (!cartHtml) return;

      const parser = new window.DOMParser();
      const cartHtmlDoc = parser.parseFromString(cartHtml, "text/html");
      const newCartContent = cartHtmlDoc.querySelector("[data-cart-content]");
      const cartQuantityElement = cartHtmlDoc.querySelector(".cart-count-bubble span:first-child");

      if (cartContentElement) {
        cartContentElement.innerHTML = newCartContent.innerHTML;
        cartContentElement.setAttribute("data-line-item-count", newCartContent.getAttribute("data-line-item-count"));
      }

      if (cartQuantityElement) {
        updateCartItemCount(cartQuantityElement.innerHTML);
      }
    }).catch(error => console.error(error));
  };

  // Define function to update cart
  const updateCartDrawer = async function(forceUpdate) {
    const cartDrawerContentElement = document.querySelector("cart-drawer");
    var updateCart = await updateCartState();
    await addRemoveGiftsFromCart(updateCart.total_price);
    await performServerAction(null, CART_DRAWER_HTML).then(cartHtml => {
      if (!cartHtml) return;

      const parserDrawer = new window.DOMParser();
      const cartHtmlDocDrawer = parserDrawer.parseFromString(cartHtml, "text/html");
      const newCartContentDrawer = cartHtmlDocDrawer.querySelector("cart-drawer");
      const cartQuantityElementDrawer = cartHtmlDocDrawer.querySelector(".cart-count-bubble span:first-child");

      if (cartDrawerContentElement) {
        cartDrawerContentElement.innerHTML = newCartContentDrawer.innerHTML;
        if (cartDrawerContentElement && cartDrawerContentElement.classList.contains('is-empty')) cartDrawerContentElement.classList.remove('is-empty');
        cartDrawerContentElement.querySelector('#CartDrawer-Overlay').addEventListener('click', cartDrawerContentElement.close.bind(cartDrawerContentElement));
      }

      if (cartQuantityElementDrawer) {
        updateCartItemCount(cartQuantityElementDrawer.innerHTML);
      }

      if (updateCart.item_count == 0) {
        cartDrawerContentElement.classList.add('is-empty')
      }

      document.querySelector('cart-drawer').open();
      
    }).catch(error => console.error(error));
  };
  
  window.RINO = window.RINO || {};
  window.RINO.cartInitialized = window.RINO.cartInitialized || false;

  let cartInitialized = window.RINO.cartInitialized;
  // if (!cartInitialized) {
    document.addEventListener("click", async (e) => {
      const addVariantTarget = e.target.closest('[data-add-variant-to-cart]');
      if (addVariantTarget) {
        e.preventDefault();
        const target = addVariantTarget;
        const itemId = target.getAttribute("data-add-variant-to-cart");
        target.classList.add("loading");

        try {
          await addItemToCart(itemId, 1, false);
          target.classList.remove("loading");
          target.classList.add("success");

          setTimeout(() => {
            target.classList.remove("success");
          }, 2500);
        } catch (error) {
          console.error(error);
        }
      }
    });

    document.addEventListener("click", (e) => {
      const removeTarget = e.target.closest('[data-line-item-remove]');
      if (removeTarget) {
        e.preventDefault();
        const itemId = removeTarget.getAttribute("data-line-item-key");
        updateCartSingleItems(itemId, 0);
      }
    });

    document.addEventListener("change", (e) => {
      if (e.target.hasAttribute("data-quantity-select")) {
        e.preventDefault();
        const itemId = e.target.getAttribute("data-line-item-key");
        updateCartSingleItems(itemId, parseInt(e.target.value, 10));
      }
    });

    window.RINO.cartInitialized = true;
  // }

  document.addEventListener("click", async (e) => {
    const addNewTarget = e.target.closest("[data-add-new]");
    if (addNewTarget) {
      e.preventDefault();
      const target = addNewTarget;
      const itemId = target.closest('form').querySelector('[name="id"]').value;
      if (target.closest('form').querySelector('[name="quantity"]')) {
        var qty = target.closest('form').querySelector('[name="quantity"]').value;
      } else {
        var qty = 1;
      }
      target.setAttribute('aria-disabled', true);
      target.classList.add('loading');
  
      try {
        await addItemToCart(itemId, qty, false);
        target.classList.remove('loading');
        target.removeAttribute('aria-disabled');
      } catch (error) {
        console.error(error);
      }
    }
  });
  

  // Remove a grouped pack (all lines sharing a packId) from the cart (vanilla; formerly jQuery)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-pack]');
    if (!btn) return;
    e.preventDefault();
    removePackFromCart(btn.getAttribute('data-remove-pack'), true);
  });

  // Height animation helper replacing jQuery slideToggle/slideUp. Respects reduced motion.
  // A timer finalizes the state even if the animation timeline is throttled (background tab).
  function slideToggle(el, duration, forceOpen) {
    var isHidden = getComputedStyle(el).display === 'none';
    var open = typeof forceOpen === 'boolean' ? forceOpen : isHidden;
    if (open === !isHidden) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) duration = 0;
    if (el._slideAnim) { el._slideAnim.onfinish = null; el._slideAnim.cancel(); el._slideAnim = null; }
    var from, to, finalize;
    if (open) {
      el.style.display = 'block';
      from = 0; to = el.scrollHeight;
      finalize = function() { el.style.overflow = ''; el.style.height = ''; el._slideAnim = null; };
    } else {
      from = el.offsetHeight; to = 0;
      finalize = function() { el.style.display = 'none'; el.style.overflow = ''; el.style.height = ''; el._slideAnim = null; };
    }
    el.style.overflow = 'hidden';
    if (!duration || typeof el.animate !== 'function') { finalize(); return; }
    var anim = el.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: duration });
    el._slideAnim = anim;
    var done = false;
    anim.onfinish = function() { if (done) return; done = true; finalize(); };
    setTimeout(function() { if (!done && el._slideAnim === anim) { done = true; try { anim.cancel(); } catch (e) {} finalize(); } }, duration + 50);
  }

  // Product page accordions (vanilla; formerly jQuery)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pdp-accordions-btn');
    if (!btn) return;
    e.preventDefault();
    var accordion = btn.closest('.pdp_accordion');
    if (!accordion) return;
    accordion.classList.toggle('active');
    accordion.querySelectorAll('.pdp-accordions-content').forEach(function(c) { slideToggle(c, 300); });
  });

  // FAQ accordions, one open at a time (vanilla; formerly jQuery)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.faq-accordions-btn');
    if (!btn) return;
    e.preventDefault();
    var current = btn.closest('.faq_accordion');
    if (!current) return;
    var wasActive = current.classList.contains('active');
    document.querySelectorAll('.faq_accordion').forEach(function(a) { a.classList.remove('active'); });
    document.querySelectorAll('.faq_accordion .faq-accordions-content').forEach(function(c) { slideToggle(c, 300, false); });
    if (!wasActive) {
      current.classList.add('active');
      current.querySelectorAll('.faq-accordions-content').forEach(function(c) { slideToggle(c, 300, true); });
    }
  });

  // Function to deactivate all active dropdowns except the current one
  function deactivateDropdowns(currentDropdown) {
      document.querySelectorAll("[data-dropdown].active").forEach(function(dropdown) {
          if (dropdown !== currentDropdown) {
              dropdown.classList.remove("active");
          }
      });
  }
  
  // Function to initialize dropdowns
  function initDropdowns(root) {
      root = root || document;
      var dropdowns = root.querySelectorAll("[data-dropdown]:not(.initialized)");
  
      // Helper function to create dropdown option button HTML
      function createDropdownOption(value, text, label) {
          return '<button class="dropdown__option" aria-label="' + label + ': ' + value + '" data-dropdown-option="' + value + '">' + text + '</button>';
      }
  
      // Helper function to set the selected dropdown option
      function setSelectedOption(container, value, text, label) {
          container.innerHTML = text;
          container.setAttribute("data-dropdown-selected", value);
          container.setAttribute("aria-label", label + ": " + value);
      }
  
      dropdowns.forEach(function(dropdown) {
          var label = dropdown.getAttribute("data-dropdown");
          var selectElement = dropdown.querySelector("select");
          var selectedContainer = dropdown.querySelector("[data-dropdown-selected]");
          var optionsContainer = dropdown.querySelector("[data-dropdown-options]");
  
          // Function to handle option selection
          function selectOption(value) {
              selectElement.value = value;
              selectElement.dispatchEvent(new Event("change"));
              dropdown.classList.remove("active");
              updateOptions();
          }
  
          // Function to update dropdown options
          function updateOptions() {
              optionsContainer.innerHTML = "";
              var options = Array.from(selectElement.options);
              if (options.length > 0) {
                  options.forEach(function(option) {
                      var value = option.value;
                      var text = option.text;
                      if (option.selected) {
                          setSelectedOption(selectedContainer, value, text, label);
                      } else {
                          optionsContainer.innerHTML += createDropdownOption(value, text, label);
                      }
                  });
  
                  dropdown.querySelectorAll("[data-dropdown-option]").forEach(function(optionButton) {
                      optionButton.addEventListener("click", function() {
                          var value = optionButton.getAttribute("data-dropdown-option");
                          selectOption(value);
                      });
                  });
              }
          }
  
          // Initial update of the dropdown options
          updateOptions();
  
          // Toggle dropdown on selected container click
          selectedContainer.addEventListener("click", function(event) {
              event.stopPropagation();
              deactivateDropdowns(dropdown);
              dropdown.classList.toggle("active");
          });
  
          // Mark the dropdown as initialized
          dropdown.classList.add("initialized");
      });
  }
  
  // Initialize dropdowns on DOM content loaded
  document.addEventListener("DOMContentLoaded", function() {
      initDropdowns();
      document.addEventListener("click", function() {
          deactivateDropdowns();
      });
  });

  document.addEventListener("DOMContentLoaded", function() {
      // Initialize Shopify query params
      function initializeShopifyQueryParams() {
          var sortElement = document.querySelector("[data-collection-sort]");
          if (sortElement) {
              Shopify.queryParams = {};
              if (location.search.length) {
                  var queries = location.search.substr(1).split("&");
                  queries.forEach(function(query) {
                      var pair = query.split("=");
                      if (pair.length) {
                          Shopify.queryParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
                      }
                  });
              }
  
              sortElement.addEventListener("change", function(event) {
                  Shopify.queryParams.sort_by = event.target.value;
                  location.search = new URLSearchParams(Shopify.queryParams).toString();
              });
          }
      }
  
      // Function to load more items
      async function loadMoreItems(url) {
          var collectionItems = document.querySelector("[data-collection-items]");
          var loadMoreGear = document.querySelector("[data-load-more-gear]");
          
          if (!collectionItems) return;
  
          if (loadMoreGear) {
              loadMoreGear.classList.add("loading");
          }
  
          try {
              var response = await fetch(url + "&view=no-layout");
              var text = await response.text();
              var doc = new DOMParser().parseFromString(text, "text/html");
  
              var newItems = doc.querySelectorAll("[data-collection-items] .product_item");
              var newLoadMoreGear = doc.querySelector("[data-load-more-gear]");
  
              if (loadMoreGear) {
                  loadMoreGear.classList.remove("loading");
                  if (newLoadMoreGear) {
                      loadMoreGear.href = newLoadMoreGear.href;
                  } else {
                      loadMoreGear.remove();
                  }
              }
  
              newItems.forEach(function(item) {
                  collectionItems.appendChild(item);
              });
          } catch (error) {
              console.error("Failed to load more items:", error);
          }
      }
  
      // Initialize event listeners
      initializeShopifyQueryParams();
  
      var loadMoreGear = document.querySelector("[data-load-more-gear]");
      if (loadMoreGear) {
          loadMoreGear.addEventListener("click", function(event) {
              event.preventDefault();
              loadMoreItems(loadMoreGear.href);
          });
      }
  });

  // Product Page

  // Define and export the throttle function
  function throttle(fn, wait) {
      var isThrottled = false;
      return function() {
          if (!isThrottled) {
              fn.apply(this, arguments);
              isThrottled = true;
              setTimeout(function() {
                  isThrottled = false;
              }, wait);
          }
      };
  }
  
  // Define and export the formatMoney function
  function formatMoney(amount) {
      var amountInDollars = amount / 100;
      var formattedAmount = amountInDollars.toLocaleString("en-US", {
          style: "currency",
          currency: "USD"
      });
      if (amountInDollars >= 1000) {
          formattedAmount = formattedAmount.replace(".00", "");
      }
      return formattedAmount;
  }
  
  // Define and export the isMobile function
  function isMobile() {
      return screen.width < 800;
  }

  // Define and export the swiperBreakpoint function
  function swiperBreakpoint(currentInstance, sliderElement, options, breakpoint, shouldCheckBelowBreakpoint) {
      // Default the shouldCheckBelowBreakpoint to true if it's not provided
      if (shouldCheckBelowBreakpoint === undefined) {
          shouldCheckBelowBreakpoint = true;
      }
  
      // Determine if the window width is below or above the breakpoint
      var isBelowBreakpoint = shouldCheckBelowBreakpoint ? screen.width < breakpoint : screen.width >= breakpoint;
  
      // If the condition is met (below or above breakpoint as specified)
      if (isBelowBreakpoint) {
          // If there's already a Swiper instance, return it
          if (currentInstance !== null) {
              return currentInstance;
          }
  
          // Otherwise, create a new Swiper instance
          var newInstance = new Swiper(sliderElement, options);
          return newInstance;
      }
  
      // If the condition is not met and there's an existing Swiper instance, destroy it
      if (currentInstance !== null) {
          currentInstance.destroy(true, true);
          return null;
      }
  
      // Return the current instance (which is null in this case)
      return currentInstance;
  }

  document.addEventListener("DOMContentLoaded", function() {
      document.querySelectorAll("[data-video-player]").forEach(function(videoPlayerElement) {
          // Get the video element and button element within the current video player element
          var video = videoPlayerElement.querySelector("video");
          var button = videoPlayerElement.querySelector("button");
  
          // Add click event listener to the button
          button.addEventListener("click", function() {
              // Enable video controls, start playing the video, and add necessary classes
              video.controls = true;
              video.play();
              video.classList.add("initialized");
              button.classList.add("hidden");
          });
  
          // Add event listener for when the video ends
          video.onended = function() {
              // Reload the video, disable controls, and show the button again
              video.load();
              video.controls = false;
              button.classList.remove("hidden");
          };
      });
      var swatchContainers = document.querySelectorAll("[data-swatch-container]");
      
      swatchContainers.forEach(function(swatchContainer) {
          var productForm = swatchContainer.closest("[data-product-form]");
          var swatchToggles = swatchContainer.querySelectorAll("[data-swatch-toggle]");
          var swatches = swatchContainer.querySelectorAll("[data-swatch]");
          
          swatches.forEach(function(swatch) {
              swatch.addEventListener("click", function() {
                  var variantId = swatch.getAttribute("data-variant-id");
                  if (variantId) {
                      var productSelect = productForm.querySelector("[data-product-select]");
                      if (productSelect) {
                          productSelect.value = variantId;
                      }
                  }
                  
                  var swatchValue = swatch.getAttribute("data-swatch");
                  if (swatchValue) {
                      swatchToggles.forEach(function(toggle) {
                          var toggleValue = toggle.getAttribute("data-swatch-toggle");
                          if (toggleValue) {
                              toggle.classList.toggle("hide", toggleValue !== swatchValue);
                          }
                      });
  
                      swatches.forEach(function(otherSwatch) {
                          var otherSwatchValue = otherSwatch.getAttribute("data-swatch");
                          if (otherSwatchValue) {
                              otherSwatch.classList.toggle("active", swatchValue === otherSwatchValue);
                          }
                      });
                  }
              });
          });
      });
  });

  document.addEventListener("DOMContentLoaded", function() {
      // Initialize Swiper Slider if exists
      (function() {
          var sliderElement = document.querySelector("[data-product-slider]");
          if (sliderElement) {
              var sliderOptions = {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  loop: true,
                  autoHeight: true,
                  pagination: {
                      el: ".swiper-pagination",
                      type: "bullets",
                      clickable: true
                  },
                  breakpoints: {
                      550: {
                          slidesPerView: 2,
                          spaceBetween: 24,
                          autoHeight: false
                      }
                  }
              };
  
              var swiperInstance = new Swiper(sliderElement, sliderOptions);
              swiperBreakpoint(swiperInstance, sliderElement, sliderOptions, 800);
  
              window.addEventListener("resize", function() {
                  swiperBreakpoint(swiperInstance, sliderElement, sliderOptions, 800);
              });
          }
      })();
  
      // Initialize Product Form if exists
      (function() {
          var productForm = document.querySelector("[data-product-form]");
          if (productForm) {
              var moneyFormat = theme.moneyFormat;
              var mainSubmitButton = productForm.querySelector("[data-product-main-submit]");
              var submitTextElement = productForm.querySelector("[data-product-submit-text]");
              var formIdElement = productForm.querySelector("[data-product-form-id]");
              var productOptions = productForm.querySelectorAll("[data-product-option]");
              var comparePriceElement = productForm.querySelector("[data-product-compare-price]");
              var priceElements = productForm.querySelectorAll("[data-product-price]");
              var productFormAttribute = productForm.getAttribute("data-product-form");
  
              var updateForm = function() {
                  var selectedOptions = [];
  
                  productOptions.forEach(function(option) {
                      if (option.getAttribute("data-product-option") === "color") {
                          var activeSwatch = option.querySelector("[data-swatch].active");
                          selectedOptions.push(activeSwatch.getAttribute("data-swatch"));
                      } else {
                          var selectElement = option.querySelector("select");
                          selectedOptions.push(selectElement.value);
                      }
                  });

                  var variant = getVariantFromOptions(productFormAttribute, selectedOptions);
                
                  if (variant && formIdElement) {
                      formIdElement.value = variant.id;
                  }
  
                  // Update Add to Cart Button
                  updateAddToCartButton(variant);
  
                  // Update Product Price
                  updateProductPrice(variant);
  
                  // Update Product Slider
                  updateProductSlider(variant);
              };
  
              var updateAddToCartButton = function(variant) {
                  var isAvailable = variant && variant.available;
                  var buttonText = isAvailable ? theme.strings.addToCart : theme.strings.unavailable;
  
                  if (isAvailable) {
                      mainSubmitButton.removeAttribute("disabled");
                  } else {
                      mainSubmitButton.setAttribute("disabled", !isAvailable);
                  }
  
                  submitTextElement.innerHTML = buttonText;
                  mainSubmitButton.setAttribute("data-marquee", buttonText);
              };
  
              var updateProductPrice = function(variant) {
                  if (variant && comparePriceElement) {
                      var hasComparePrice = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
  
                      if (hasComparePrice) {
                          comparePriceElement.innerHTML = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
                      }
  
                      comparePriceElement.classList.toggle("hide", !hasComparePrice);
  
                      priceElements.forEach(function(priceElement) {
                          priceElement.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
                          priceElement.classList.toggle("red", hasComparePrice);
                      });
                  }
              };
  
              var updateProductSlider = function(variant) {
                  var mediaId = variant && variant.featured_media && variant.featured_media.id;
  
                  if (mediaId && isMobile()) {
                      var slider = document.querySelector("[data-product-slider]");
                      var slides = slider && slider.querySelectorAll("[data-product-slide]");
  
                      if (slider && slides) {
                          slides.forEach(function(slide, index) {
                              var slideId = slide.getAttribute("data-product-slide");
                              var swiper = slider.swiper;
  
                              if (swiper && slideId === mediaId.toString()) {
                                  swiper.params.speed = 0;
                                  swiper.slideTo(index);
                                  swiper.params.speed = 400;
                              }
                          });
                      }
                  }
              };
  
              productOptions.forEach(function(option) {
                  if (option.getAttribute("data-product-option") === "color") {
                      var swatches = option.querySelectorAll("[data-swatch]");
                      swatches.forEach(function(swatch) {
                          swatch.addEventListener("click", function() {
                              swatches.forEach(function(otherSwatch) {
                                  otherSwatch.classList.toggle("active", otherSwatch === swatch);
                              });
                              var color = this.dataset.swatch;
                              productForm.querySelector(".currentColor").innerHTML = color;
                              updateForm();
                          });
                      });
                  } else {
                      var selectElement = option.querySelector("select");
                      selectElement.addEventListener("change", updateForm);
                  }
              });
  
              // Initial update
              // updateForm();
          }
      })();
  });
  
  function toggleActiveClass(elements, attribute, value) {
      for (var i = 0; i < elements.length; i++) {
          var element = elements[i];
          var attributeValue = element.getAttribute(attribute);
          element.classList.toggle("active", attributeValue === value);
      }
  }
  function updateProductForm(variantId) {
      var productForm = document.querySelector("[data-product-form]");
      if (productForm) {
          var variant = getVariant(variantId);
          var submitButton = productForm.querySelector("[data-premium-submit]");
          var submitText = productForm.querySelector("[data-premium-submit-text]");
          if (variant && submitButton && submitText) {
              var isAvailable = variant.available;
              var buttonText = isAvailable ? theme.strings.addToCart : theme.strings.unavailable;
              if (isAvailable) {
                  submitButton.removeAttribute("disabled");
              } else {
                  submitButton.setAttribute("disabled", !isAvailable);
              }
              submitText.innerHTML = buttonText;
              submitButton.setAttribute("data-marquee", buttonText);
          }
      }
  }
  function setupHero() {
      var hero = document.querySelector("[data-premium-hero]");
      if (hero) {
          var productSelect = hero.querySelector("[data-product-select]");
          if (productSelect) {
              var galleries = hero.querySelectorAll("[data-gallery]");
              var galleryThumbs = hero.querySelectorAll("[data-gallery-thumbs]");
              var swatches = hero.querySelectorAll("[data-swatch]");
              for (var i = 0; i < swatches.length; i++) {
                  var swatch = swatches[i];
                  var variantId = swatch.getAttribute("data-variant-id");
                  swatch.addEventListener("click", (function(galleries, swatches, galleryThumbs, variantId, productSelect) {
                      return function() {
                          // toggleActiveClass(galleries, "data-gallery", variantId);
                          toggleActiveClass(swatches, "data-variant-id", variantId);
                          // toggleActiveClass(galleryThumbs, "data-gallery-thumbs", variantId);
                          var color = this.dataset.swatch;
                          hero.querySelector(".currentColor").innerHTML = color;
                          updateProductForm(variantId);
                          productSelect.value = variantId;
                      };
                  })(galleries, swatches, galleryThumbs, variantId, productSelect));
              }
          }
      }
  }

  document.addEventListener("DOMContentLoaded", function() {
    setupHero()
  });


window.addEventListener('scroll', function() {
  var header = document.querySelector('sticky-header');
  if (header && typeof header.setHeaderHeight === 'function') header.setHeaderHeight();
}, { passive: true });
